<template>
  <div>
    <Header />
    <b-container>
      <Breadcrumb />
      <b-row>
        <b-col cols="12" lg="2" class="mypage__sidebar mypage__sidebar-mb">
          <SidebarMypage />
        </b-col>
        <b-col cols="12" lg="1"></b-col>
        <b-col cols="12" lg="8">
          <div class="notification">
            <div class="w-100">
              <div class="w-100 d-flex justify-content-between align-items-center noti-box">
                <div>新規ファイルアップロード</div>
                <label class="switch">
                  <input type="checkbox">
                  <span class="slider round"></span>
                </label>
              </div>
              <div class="w-100 d-flex justify-content-between align-items-center noti-box">
                <div>新規ファイルアップロード</div>
                <label class="switch">
                  <input type="checkbox" checked>
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import SidebarMypage from '@/views/Manager/MyPage/SidebarMypage'
import Header from '@/components/share/Header'
import Breadcrumb from '@/components/share/Breadcrumb'
export default {
  name: 'SettingNotification',
  components: {
    Header,
    SidebarMypage,
    Breadcrumb
  },
  data () {
    return {
    }
  }
}
</script>
<style scoped lang="scss">
  @import "@/assets/stylesheet/mypage/detail_mypage.scss";
</style>



// WEBPACK FOOTER //
// src/views/Manager/MyPage/SettingNotification.vue